import React, {useState} from "react";
import carouselImg1 from '../img/homepage-slim/band3-2025.jpg';
import carouselImg2 from '../img/homepage-slim/band4-2025.jpg';
import carouselImg3 from '../img/homepage-slim/band5-2025.jpg';
import carouselImg4 from '../img/homepage-slim/band6-2025.jpg';
import carouselImg5 from '../img/homepage-slim/band2-2025.jpg';
import carouselImg6 from '../img/homepage-slim/band1-2025.jpg';

import fomImg from '../img/FOM_logo.jpg';
import wccImg from '../img/wcc-logo-text.png';
import Container from "react-bootstrap/Container";
import {Alert, Carousel, Col, Row} from "react-bootstrap";
import PFDateAndDesc from "../common/pfDateAndDesc";


const Home = () => {
    const [index, setIndex] = useState(0);
    let carouselImg = [carouselImg1, carouselImg2, carouselImg3, carouselImg4, carouselImg5, carouselImg6]

    const handleSelect = (selectedIndex) => {
        setIndex(selectedIndex);
    };

    return (
        <>
            <Container fluid>
                <Row className="justify-content-md-center">
                    <Col className="mx-auto">

                        <Carousel activeIndex={index} onSelect={handleSelect}>
                            {Array.from({length: 6}).map((_, index) => (
                                <Carousel.Item key={index}>
                                    <img src={carouselImg[(index)]} alt="pf band" className="img-fluid"/>
                                </Carousel.Item>
                            ))}
                        </Carousel>
                        <br/>

                        <Alert variant="primary">
                            <PFDateAndDesc/>
                        </Alert>
                    </Col>
                </Row>
            </Container>

            <Container fluid className="home-footer">
                <Row className="mb-3">
                    <Col className="mx-auto">
                        <p className="text-muted, small">
                            Please note that by attending Winchester Porchfest, you agree that you are participating at
                            your own risk and will hold performers, hosts, volunteers, and/or organizers free of any
                            liability and/or claim for damages in the event of disappointment, accident, or injury. You
                            also agree to be photographed and/or filmed.
                        </p>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col className="mx-auto social">
                        <a href="https://www.facebook.com/Winchester-Porch-Fest-108163394041876/"
                           className="social-links facebook" target="_blank" rel="noreferrer"><i
                            className="bi bi-facebook"></i></a>
                        <a href="https://x.com/WPorchfest"
                           className="social-links twitter" target="_blank" rel="noreferrer"><i
                            className="bi bi-twitter-x"></i></a>
                        <a href="https://www.instagram.com/winporchfest/"
                           className="social-links instagram" target="_blank" rel="noreferrer"><i
                            className="bi bi-instagram"></i></a>
                        &nbsp;
                        &nbsp;
                        &nbsp;
                        <a href="https://fomwps.wixsite.com/winchester-music" target="_blank" rel="noreferrer"
                           className="sponsor">
                            <img src={fomImg} alt="Winchester Friends of Music"/>
                        </a>
                        <a href="https://winchesterculturalcouncil.org" target="_blank" rel="noreferrer"
                           className="sponsor">
                            <img src={wccImg} alt="Winchester Cultural Council"/>
                        </a>
                        {/*<a href="https://massculturalcouncil.org" target="_blank" rel="noreferrer" className="sponsor">*/}
                        {/*    <img src={mccImg} alt="Mass Cultural Council" style={{maxWidth: "60px"}}/>*/}
                        {/*</a>*/}
                    </Col>
                </Row>
                {/*<Row>*/}
                {/*    <Col className="mx-auto">*/}
                {/*        <div className="sponsors-hp pt-1">*/}
                {/*            This program is supported in part by a grant from the Winchester Cultural Council.*/}
                {/*        </div>*/}
                {/*    </Col>*/}
                {/*</Row>*/}
            </Container>
        </>
    );
}

export default Home;
